import api from './api';

/**
 * EDI Locations (cms.edi_locations) — persists the four editable fields on a partner
 * location: the mapped CMS location (locationcode), Terminal (rail), Auto Accept and
 * Deleted. The grid is the read-only /tablemaint engine (key 'edi-locations'); the
 * partner-supplied address block is never written here.
 */

/** Full edi_locations row — the exact shape the tablemaint edit drawer consumes
 *  (edi_locations fields + the mapped cms.locations lname/lcity/lstate). */
export interface EdiLocationRow {
  recno: number;
  edihandle: string;
  name: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  locationcode: number;
  rail: string;
  partnercode: string;
  autoaccept: string;
  deleted: string;
  lname: string;
  lcity: string;
  lstate: string;
  [k: string]: any;
}

/** Fetch a single edi_locations record (for opening the edit drawer from a recno,
 *  e.g. the Pending EDI Orders "Map Location" links). */
export async function getEdiLocation(recno: number): Promise<EdiLocationRow> {
  const r = await api.get<EdiLocationRow>(`/edi-locations/${recno}`);
  return r.data;
}

export async function updateEdiLocation(
  recno: number,
  patch: { locationcode?: number; rail?: string; autoaccept?: string; deleted?: string },
): Promise<void> {
  await api.put(`/edi-locations/${recno}`, patch);
}
